import {
  Component,
  EventEmitter,
  Output,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { UserService } from '../../../../../services/user';
import { DeviceDetectorService } from '../../../../../services/device-detector.service';
import { Router } from '@angular/router';
import { Address } from '../../../../../interfaces/address';
import { UserAddresses } from '../../../../../services/userAddresses';
import { GovernoratesService } from '../../../../../services/governorates.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-useraddresses',
  templateUrl: './useraddresses.component.html',
  styleUrl: './useraddresses.component.scss'
})
export class UseraddressesComponent implements OnInit {

  @Output() fees = new EventEmitter<any>();

  isAr = false;
  id = '';
  contentReady = true;

  addresses: Address[] = [];
  isCreateOrder = false;
  selectedAddress: Address | null = null;
  deliveryFees!: any;

  private isBrowser: boolean;

  constructor(
    private _userService: UserService,
    private governoratesService: GovernoratesService,
    private deviceService: DeviceDetectorService,
    private addressService: UserAddresses,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ================= INIT =================
  ngOnInit(): void {

    this.contentReady = true;

    // language → browser only
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.userId();
    this.loadAddresses();

    if (this._router.url === '/Addorderclient') {
      this.isCreateOrder = true;
    }
  }

  // ================= DELIVERY PRICE =================
  getPrice(id: number): void {
    this.contentReady = true;

    this.governoratesService.getGovernoratePrice(id).subscribe({
      next: (res) => {
        this.deliveryFees = res.price;
        this.fees.emit(this.deliveryFees);
        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      }
    });
  }

  // ================= ADDRESS SELECTION =================
  chooseAddress(address: Address): void {

    if (!this.isCreateOrder) return;

    this.selectedAddress = address;
    this.getPrice(address.government_id!);

    if (this.isBrowser) {
      localStorage.setItem('shipping', JSON.stringify(address));
    }
  }

  // ================= DELETE =================
  delete(id: any): void {
    this.contentReady = true;

    this.addressService.deleteAddress(id).subscribe({
      next: () => {
        this.loadAddresses();
        if (this.isBrowser) {
          localStorage.removeItem('shipping');
        }
      },
      error: () => this.contentReady = false
    });
  }

  // ================= LOAD =================
  loadAddresses(): void {
    this.addressService.getAddresses().subscribe({
      next: (res) => {
        this.addresses = res;
        this.contentReady = false;

        if (this.isCreateOrder && this.addresses.length > 0) {
          this.selectedAddress = this.addresses[0];

          if (this.isBrowser) {
            localStorage.setItem('shipping', JSON.stringify(this.addresses[0]));
          }

          this.getPrice(this.addresses[0].government_id!);
        }
      },
      error: () => {
        this.contentReady = false;
      }
    });
  }

  // ================= USER =================
  userId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.id = data.user_id;
      },
      error: () => {
        this.contentReady = false;
      }
    });
  }

  // ================= EDIT =================
  edit(address: Address): void {
    this._router.navigate(['/addaddress'], {
      queryParams: { address }
    });
  }
}
